import { jwtDecode } from 'jwt-decode';

export enum UserRole {
    ADMIN = 'admin',
    OWNER = 'owner',
    CLERK = 'clerk',
}

export const STAFF_ROLES: UserRole[] = [UserRole.ADMIN, UserRole.OWNER, UserRole.CLERK];

export const MANAGEMENT_ROLES: UserRole[] = [UserRole.ADMIN, UserRole.OWNER];

export const generateRandomUUID = () => {
    return crypto.randomUUID();
}

export function validateToken(token: string) {
    const payload = jwtDecode(token);
    return payload;
}

export function hasRole(role: UserRole | null | undefined, allowedRoles: UserRole[]) {
    return !!role && allowedRoles.includes(role);
}
